import { DeliveryRequest } from './deliveryRequest';
import { HistoryViewItemLevel } from './history';
import { Orders } from './orders';
import { FileUploadInterface, Profile } from './Profile';
import { Inward } from './inwards';
import { ReceivingDelivery } from './ReceivingDelivery';
import { MetaDataElement } from './metaDataConfig';

export interface FilterAssetsDetailsI {
  assetCleanedThisMonth: number;
  currentMonthAssetCanMovement: number;
  deliveryAssetApproved: number;
  deliveryAssetPickerAssigned: number;
  deliveryOrdercreated: number;
  newAssetTitlesAddedInThisMonth: number;
  orderRegistered: number;
  pendingReturnsFromBorrower: number;
  readyfordelivery: number;
  receivingOrderCreated: number;
  tagged: number;
  currentCount?: number;
}

export interface Activity {
  id: any;
  description: string;
  asset_Id:string;
  type: string;
  element: string;
  status: string;
  calculated_category: number;
  physical_sensor_barcode: string;
  gauge_type: string;
  reel_no: string;
  number_of_element: string;
  physical_sensor_NFC: string;
  physical_sensor_RFID: string;
  physical_location_rack: string;
  physical_location_shelf: string;
  physical_location_vault: string;
  physical_sensor_qrcode: string;
  elementtypeid: string;
  originIndia?: string;
  language: string;
  title: string;
  year: string;
  original_title: string;
  translated_title: string;
  alternative_title: string;
  country_production: string;
  original_language_origin: string;
  original_language: string;
  dubbed_language_origin: string;
  dubbed_language: string;
  released_unreleased: string;
  year_reference: string;
  certification_no: string;
  certification_date: string;
  certification_center: string;
  work_category: string;
  length_of_film: string;
  duration: string;
  total_can_count?: number;
  banner: string;
  production_company: string;
  producer: string;
  associate_producer: string;
  executive_producer: string;
  director: string;
  story: string;
  screen_play: string;
  dialogue: string;
  cinematography: string;
  photography: string;
  editing: string;
  art_direction: string;
  sound_recordist: string;
  sound_mixing: string;
  sound_designer: string;
  sound_effects: string;
  dubbing: string;
  music: string;
  music_background_score: string;
  lyrics: string;
  songs: string;
  cast: string;
  playback_singers: string;
  costume: string;
  action: string;
  choreography: string;
  make_up: string;
  associate_director: string;
  associate_directors: string;
  other_assistants: string;
  production_manager: string;
  production_studio: string;
  film_processing_laboratory: string;
  order_tracking: string;
  vfx: string;
  animation: string;
  colorist: string;
  cgi: string;
  di: string;
  public_designer: string;
  original_production_format: string;
  awards: string;
  screening: string;
  notes: string;
  copyright: string;
  audio_right: string;
  recording_company: string;
  asset_tracking_status: string;
  keywords: string;
  curatorial_notes: string;
  thumbnail_small: string;
  thumbnail_large: string;
  hostUsername?: string;
  isCancelled?: boolean;
  isHost?: boolean;
  host?: Profile;
  proxy: string;
  file: string;
  size: string;
  last_modified: string;
  itemCreatedAt: string;
  itemCreatedBy: string;
  content_created: string;
  encodeder: string;
  file_format: string;
  durationn: string;
  timecode: string;
  video: string;
  global_positioning_system: string;
  name: string;
  ingest_server: string;
  technical_type: string;
  source_name: string;
  tc_start: string;
  tc_End: string;
  tc_duaration: string;
  play_duration: string;
  tracks: string;
  tape: string;
  frame_rate: string;
  video_format: string;
  compression: string;
  orientation: string;
  aspect_ratio: string;
  physcial_format: string;
  track_format: string;
  groove_type: string;
  speed_and_speed_adjustment: string;
  number_of_channels_and_sound_channel_map: string;
  sampling_frequency: string;
  audio_data_encoding: string;
  file_format_name_and_version: string;
  dimensions: string;
  analog_media: string;
  frame_description: string;
  data_rate: string;
  format_in_terms_of_broadcast_standards: string;
  formatting_description: string;
  bits_per_sample_and_sampling_description: string;
  synopsis: string;
  animator: string;
  lyricist: string;
  thumbnail?: string;
  preview?: string;
  receivingdate: string;
  movementdate: string;
  maintenance: string;
  cloned_From: string;
  digitalization_priority: number;
  assignedUsers?: Profile[];
  itemHistory: HistoryViewItemLevel[];
  itemDeliveryRequest: DeliveryRequest[];
  orders: Orders[];
  inwards: Inward[];
  files: FileUploadInterface[];
  // filess:FileUploadInterface[]
  receivings: ReceivingDelivery[];
  current_task: string;
  current_subtask: string;
  isReceiving: boolean;
  isReceivingOrder: boolean;
  isDelivery: boolean;
  metadata: MetaDataElement[];
  sections_From?: string;
  sections_Multiple_From?: string;
  existing: string;
  typeid: string;
  clearedon: string;
  current_user: string;
  status_Time: string;
  isActive: boolean;
  isDeleted: boolean;
  receiver_Status: string;
  receiver: string;
  asset_In_Vault: string;
  registerId: string;
  projectStartDate?: string;
  projectEndDate?: string;
  issuer: string;
  isMaster?: string;
  movement_Time: string;
  assetCondition?: string;
  parent?:string
  make_Or_Model_No?:string
}

export interface VerifyItemLevel {
  id: string;
  type: string;
  element: string;
  reel_no: string;
  gauge_type: string;
  number_of_element: string;
}

export class Activity implements Activity {
  constructor(init?: ActivityFormValues) {
    Object.assign(this, init);
  }
}

export class ActivityFormValues {
  id?: string = '';
  description?: string = '';
  type?: string = '';
  element?: string = '';
  reel_no?: string = '';
  gauge_type?: string = '';
  status?: string = '';
  receivingdate?: string = '';
  movementdate?: string = '';
  maintenance?: string = '';
  digitalization_priority?: number = 0;
  number_of_element?: string = '';
  calculated_category?: number = 0;
  physical_sensor_barcode?: string = '';
  physical_sensor_NFC?: string = '';
  physical_sensor_RFID?: string = '';
  asset_Id?:string = '';
  physical_location_rack?: string = '';
  physical_location_shelf?: string = '';
  physical_location_vault?: string = '';
  physical_sensor_qrcode?: string = '';
  originIndia?: string = '';
  language?: string = '';
  title?: string = '';
  year: string = '';
  original_title?: string = '';
  translated_title?: string = '';
  alternative_title?: string = '';
  country_production?: string = '';
  original_language_origin?: string = '';
  original_language?: string = '';
  dubbed_language_origin?: string = '';
  dubbed_language?: string = '';
  elementtypeid?: string = '';
  original_production_format?: string = '';
  released_unreleased?: string = '';
  year_reference: string = '';
  certification_no?: string = '';
  certification_date: string = '';
  certification_center?: string = '';
  work_category?: string = '';
  length_of_film?: string = '';
  duration?: string = '';
  total_can_count?: number;
  banner?: string = '';
  production_company?: string = '';
  producer?: string = '';
  associate_producer?: string = '';
  executive_producer?: string = '';
  director?: string = '';
  story?: string = '';
  screen_play?: string = '';
  dialogue?: string = '';
  cinematography?: string = '';
  current_task?: string = '';
  current_subtask: string = '';
  photography?: string = '';
  editing?: string = '';
  art_direction?: string = '';
  sound_recordist?: string = '';
  sound_mixing?: string = '';
  sound_designer?: string = '';
  sound_effects?: string = '';
  dubbing?: string = '';
  music?: string = '';
  music_background_score?: string = '';
  lyrics?: string = '';
  songs?: string = '';
  cast?: string = '';
  playback_singers?: string = '';
  costume?: string = '';
  action?: string = '';
  choreography?: string = '';
  make_up?: string = '';
  associate_director?: string = '';
  associate_directors?: string = '';
  other_assistants?: string = '';
  production_manager?: string = '';
  production_studio?: string = '';
  film_processing_laboratory?: string = '';
  order_tracking?: string = '';
  vfx?: string = '';
  animation?: string = '';
  colorist?: string = '';
  cgi?: string = '';
  di?: string = '';
  public_designer?: string = '';
  awards?: string = '';
  screening?: string = '';
  notes?: string = '';
  copyright?: string = '';
  audio_right?: string = '';
  recording_company?: string = '';
  asset_tracking_status?: string = '';
  keywords?: string = '';
  curatorial_notes?: string = '';
  thumbnail_small?: string = '';
  thumbnail_large?: string = '';
  proxy?: string = '';
  file?: string = '';
  size?: string = '';
  last_modified?: string = '';
  itemCreatedAt?: string = new Date().toString();
  itemCreatedBy?: string = '';
  content_created?: string = '';
  encodeder?: string = '';
  file_format?: string = '';
  durationn?: string = '';
  timecode?: string = '';
  video?: string = '';
  global_positioning_system?: string = '';
  name?: string = '';
  ingest_server?: string = '';
  technical_type?: string = '';
  source_name?: string = '';
  tc_start?: string = '';
  tc_End?: string = '';
  tc_duaration?: string = '';
  play_duration?: string = '';
  tracks?: string = '';
  tape?: string = '';
  frame_rate?: string = '';
  video_format?: string = '';
  compression?: string = '';
  orientation?: string = '';
  aspect_ratio?: string = '';
  physcial_format?: string = '';
  track_format?: string = '';
  groove_type?: string = '';
  speed_and_speed_adjustment?: string = '';
  number_of_channels_and_sound_channel_map?: string = '';
  sampling_frequency?: string = '';
  audio_data_encoding?: string = '';
  file_format_name_and_version?: string = '';
  dimensions?: string = '';
  analog_media?: string = '';
  frame_description?: string = '';
  data_rate?: string = '';
  format_in_terms_of_broadcast_standards?: string = '';
  formatting_description?: string = '';
  bits_per_sample_and_sampling_description?: string = '';
  synopsis?: string = '';
  animator?: string = '';
  typeid?: string = '';
  lyricist?: string = '';
  thumbnail?: string;
  preview?: string;
  isReceiving?: boolean = false;
  isReceivingOrder?: boolean = false;
  isDelivery?: boolean = false;
  receiver_Status?: string;
  receiver?: string;
  asset_In_Vault?: string = '';
  sections_Multiple_From?: string = '';
  existing?: string = '';
  registerId?: string = '';
  issuer?: string = '';
  isMaster?: string = '';
  movement_Time?: string = '';
  parent?:string = ''
  make_Or_Model_No?:string = '' // PCPLCRM Customer IT Team Update 
  // cloned_From?: string='';
  constructor(activity?: ActivityFormValues) {
    if (activity) {
      this.id = activity.id;
      this.description = activity.description;
      this.type = activity.type;
      this.number_of_element = activity.number_of_element;
      this.reel_no = activity.reel_no;
      this.gauge_type = activity.gauge_type;
      this.element = activity.element;
      this.elementtypeid = activity.elementtypeid;
      this.status = activity.status;
      this.calculated_category = activity.calculated_category;
      this.physical_sensor_barcode = activity.physical_sensor_barcode;
      this.physical_sensor_NFC = activity.physical_sensor_NFC;
      this.physical_sensor_RFID = activity.physical_sensor_RFID;
      this.physical_location_rack = activity.physical_location_rack;
      this.physical_location_shelf = activity.physical_location_shelf;
      this.physical_location_vault = activity.physical_location_vault;
      this.physical_sensor_qrcode = activity.physical_sensor_qrcode;
      this.originIndia = activity.originIndia;
      this.language = activity.language;
      this.title = activity.title;
      this.year = activity.year;
      this.digitalization_priority = activity.digitalization_priority;
      this.original_title = activity.original_title;
      this.translated_title = activity.translated_title;
      this.alternative_title = activity.alternative_title;
      this.country_production = activity.country_production;
      this.original_language_origin = activity.original_language_origin;
      this.original_language = activity.original_language;
      this.dubbed_language_origin = activity.dubbed_language_origin;
      this.dubbed_language = activity.dubbed_language;
      this.original_production_format = activity.original_production_format;
      this.released_unreleased = activity.released_unreleased;
      this.year_reference = activity.year_reference;
      this.certification_no = activity.certification_no;
      this.certification_date = activity.certification_date;
      this.certification_center = activity.certification_center;
      this.work_category = activity.work_category;
      this.length_of_film = activity.length_of_film;
      this.duration = activity.duration;
      this.total_can_count = activity.total_can_count;
      this.banner = activity.banner;
      this.production_company = activity.production_company;
      this.producer = activity.producer;
      this.associate_producer = activity.associate_producer;
      this.executive_producer = activity.executive_producer;
      this.director = activity.director;
      this.current_task = activity.current_task;
      this.current_subtask = activity.current_subtask;
      this.story = activity.story;
      this.screen_play = activity.screen_play;
      this.dialogue = activity.dialogue;
      this.cinematography = activity.cinematography;
      this.photography = activity.photography;
      this.editing = activity.editing;
      this.art_direction = activity.art_direction;
      this.sound_recordist = activity.sound_recordist;
      this.sound_mixing = activity.sound_mixing;
      this.sound_designer = activity.sound_designer;
      this.sound_effects = activity.sound_effects;
      this.dubbing = activity.dubbing;
      this.music = activity.music;
      this.music_background_score = activity.music_background_score;
      this.lyrics = activity.lyrics;
      this.songs = activity.songs;
      this.cast = activity.cast;
      this.playback_singers = activity.playback_singers;
      this.costume = activity.costume;
      this.action = activity.action;
      this.choreography = activity.choreography;
      this.make_up = activity.make_up;
      this.associate_director = activity.associate_director;
      this.associate_directors = activity.associate_directors;
      this.other_assistants = activity.other_assistants;
      this.production_manager = activity.production_manager;
      this.production_studio = activity.production_studio;
      this.film_processing_laboratory = activity.film_processing_laboratory;
      this.order_tracking = activity.order_tracking;
      this.vfx = activity.vfx;
      this.animation = activity.animation;
      this.colorist = activity.colorist;
      this.cgi = activity.cgi;
      this.di = activity.di;
      this.public_designer = activity.public_designer;
      this.awards = activity.awards;
      this.screening = activity.screening;
      this.notes = activity.notes;
      this.copyright = activity.copyright;
      this.audio_right = activity.audio_right;
      this.recording_company = activity.recording_company;
      this.asset_tracking_status = activity.asset_tracking_status;
      this.keywords = activity.keywords;
      this.curatorial_notes = activity.curatorial_notes;
      this.thumbnail_small = activity.thumbnail_small;
      this.thumbnail_large = activity.thumbnail_large;
      this.proxy = activity.proxy;
      this.movementdate = activity.movementdate;
      this.receivingdate = activity.receivingdate;
      this.maintenance = activity.maintenance;
      this.file = activity.file;
      this.size = activity.size;
      this.last_modified = activity.last_modified;
      this.itemCreatedAt = activity.itemCreatedAt;
      this.itemCreatedBy = activity.itemCreatedBy;
      this.content_created = activity.content_created;
      this.encodeder = activity.encodeder;
      this.file_format = activity.file_format;
      this.durationn = activity.durationn;
      this.timecode = activity.timecode;
      this.video = activity.video;
      this.global_positioning_system = activity.global_positioning_system;
      this.name = activity.name;
      this.ingest_server = activity.ingest_server;
      this.technical_type = activity.technical_type;
      this.source_name = activity.source_name;
      this.tc_start = activity.tc_start;
      this.tc_End = activity.tc_End;
      this.tc_duaration = activity.tc_duaration;
      this.play_duration = activity.play_duration;
      this.tracks = activity.tracks;
      this.tape = activity.tape;
      this.frame_rate = activity.frame_rate;
      this.video_format = activity.video_format;
      this.compression = activity.compression;
      this.orientation = activity.orientation;
      this.aspect_ratio = activity.aspect_ratio;
      this.physcial_format = activity.physcial_format;
      this.track_format = activity.track_format;
      this.groove_type = activity.groove_type;
      this.speed_and_speed_adjustment = activity.speed_and_speed_adjustment;
      this.number_of_channels_and_sound_channel_map =
        activity.number_of_channels_and_sound_channel_map;
      this.sampling_frequency = activity.sampling_frequency;
      this.audio_data_encoding = activity.audio_data_encoding;
      this.file_format_name_and_version = activity.file_format_name_and_version;
      this.dimensions = activity.dimensions;
      this.analog_media = activity.analog_media;
      this.frame_description = activity.frame_description;
      this.data_rate = activity.data_rate;
      this.format_in_terms_of_broadcast_standards =
        activity.format_in_terms_of_broadcast_standards;
      this.formatting_description = activity.formatting_description;
      this.bits_per_sample_and_sampling_description =
        activity.bits_per_sample_and_sampling_description;
      this.synopsis = activity.synopsis;
      this.animator = activity.animator;
      this.lyricist = activity.lyricist;
      this.thumbnail = activity.thumbnail;
      this.preview = activity.preview;
      this.existing = activity.existing;
      // this.itemDelivery=activity.itemDelivery
      this.isReceiving = activity.isReceiving;
      this.isReceivingOrder = activity.isReceivingOrder;
      this.isDelivery = activity.isDelivery;
      // this.cloned_From = activity.cloned_From;
      this.receiver_Status = activity.receiver_Status;
      this.receiver = activity.receiver;
      this.asset_In_Vault = activity.asset_In_Vault;
      this.sections_Multiple_From = activity.sections_Multiple_From;
      this.registerId = activity.registerId;
      this.issuer = activity.issuer;
      this.isMaster = activity.isMaster;
      this.movement_Time = activity.movement_Time;
    }
  }
}

export interface HFCregisterWorkLevel {
  id: string;
  title: string;
  hostUsername: string;
  typeid: string;
  type: string;
  elementtypeid: string;
  departmentId: string;
  departmentName: string;
  element: string;
  number_of_element: string;
  synopsis: string;
  itemCreatedAt: string;
  order_tracking: string;
  asset_tracking_status: string;
  receivingdate: string;
  movementdate: string;
  maintenance: string;
  digitalization_priority: number;
  calculated_category: number;
  clearedon: string;
  current_user: string;
  current_task: string;
  current_subtask: string;
  status_Time: string;
  isReceivingOrder: boolean;
  thumbnail: string;
  proxy: string;
  preview: string;
  physical_sensor_qrcode: string;
  physical_sensor_barcode: string;
  physical_sensor_RFID: string;
  physical_sensor_NFC: string;
  physical_location_vault: string;
  physical_location_rack: string;
  physical_location_shelf: string;
  global_positioning_system: string;
  asset_In_Vault: string;
  movement_Time: string;
  isActive: boolean;
  isDeleted: boolean;
  status: string;
  issuer: string;
  receiver: string;
  receiver_Status: string;
  cloned_From: string;
  parent: string;
  existing: string;
  ftpPath: string;
  assetCondition: string;
  isReceiving: boolean;
  isDelivery: boolean;
  isMaster: boolean;
  projectStartDate: string;
  projectEndDate: string;
  itemCreatedBy: string;
  registerId: string;
  version: string;
  metadata: MetaDataElement[];
  files: FileUploadInterface[];
  assignedUsers:  Profile[];
  itemDeliveryRequest: DeliveryRequest[];
  inwards: Inward[];
  itemHistory: HistoryViewItemLevel[];
}

export const initialHFCActivityState: HFCregisterWorkLevel = {
  id: '',
  title: '',
  hostUsername: '',
  typeid: '',
  type: '',
  elementtypeid: '',
  departmentId: '',
  departmentName: '',
  element: '',
  number_of_element: '',
  synopsis: '',
  itemCreatedAt: '',
  order_tracking: '',
  asset_tracking_status: '',
  receivingdate: '',
  movementdate: '',
  maintenance: '',
  digitalization_priority: 0,
  calculated_category: 0,
  clearedon: '',
  current_user: '',
  current_task: '',
  current_subtask: '',
  status_Time: '',
  isReceivingOrder: false,
  thumbnail: '',
  proxy: '',
  preview: '',
  physical_sensor_qrcode: '',
  physical_sensor_barcode: '',
  physical_sensor_RFID: '',
  physical_sensor_NFC: '',
  physical_location_vault: '',
  physical_location_rack: '',
  physical_location_shelf: '',
  global_positioning_system: '',
  asset_In_Vault: '',
  movement_Time: '',
  isActive: false,
  isDeleted: false,
  status: '',
  issuer: '',
  receiver: '',
  receiver_Status: '',
  cloned_From: '',
  parent: '',
  existing: '',
  ftpPath: '',
  assetCondition: '',
  isReceiving: false,
  isDelivery: false,
  isMaster: false,
  projectStartDate: '',
  projectEndDate: '',
  itemCreatedBy: '',
  registerId: '',
  version: '',
  metadata: [],
  files: [],
  assignedUsers: [],
  itemDeliveryRequest:[],
  inwards:[],
  itemHistory: [],
};